import { FILE_NAME_DELIMITER, FILE_NAME_PREFIX } from "../constants";

export const getDocumentFileName = (documentType, prospectId, fileName) => {
  const formattedName = sanitizeName(documentType);
  const fileExtension = fileName.split(".").pop();
  const documentKey = "." + fileExtension;
  const now = new Date().getTime();
  const modifiedFileName =
    FILE_NAME_PREFIX +
    FILE_NAME_DELIMITER +
    prospectId +
    FILE_NAME_DELIMITER +
    formattedName +
    FILE_NAME_DELIMITER +
    now +
    documentKey;
  return modifiedFileName;
};

const sanitizeName = documentType => {
  const maxLength = documentType ? Math.min(documentType.length, 100) : 100;
  return documentType.replace(/[:\\\\/*?|<>]/g, FILE_NAME_DELIMITER).substring(0, maxLength);
};
